import { lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import useReduxStore from '../hooks/useReduxStore'
import { Toaster } from 'react-hot-toast'
import Page404 from '../components/Page404'
import { UserReportIndex } from '../pages/revenue_reports/userReports/UserReportIndex'
import { ServiceReportIndex } from '../pages/revenue_reports/serviceReport/ServiceReportIndex'
import { FinancialReportIndex } from './../pages/revenue_reports/financialReport/FinancialReportIndex'
import { TotalRegisteredUsers } from '../pages/revenue_reports/userReports/TotalRegisteredUsers'
import { ActiveInactiveUsers } from '../pages/revenue_reports/userReports/ActiveInactiveUsers'
import { GrowthTrendsUsers } from '../pages/revenue_reports/userReports/GrowthTrendsUsers'
import { DemographicsUsers } from '../pages/revenue_reports/userReports/DemographicsUsers'
import { TopEngagedUsers } from '../pages/revenue_reports/userReports/TopEngagedUsers'
import { TotalRequestsPerService } from '../pages/revenue_reports/serviceReport/TotalRequestsPerService'
import { AverageResolutionTime } from '../pages/revenue_reports/serviceReport/AverageResolutionTime'
import { Booking } from '../pages/revenue_reports/financialReport/Booking'
import { Commission } from '../pages/revenue_reports/financialReport/Commission'
import { PaymentReceived } from '../pages/revenue_reports/financialReport/PaymentReceived'
import { Refund } from '../pages/revenue_reports/financialReport/Refund'
import { ReleasePayment } from '../pages/revenue_reports/financialReport/ReleasePayment'
import { RevenueBreakdown } from '../pages/revenue_reports/financialReport/RevenueBreakdown'
import { RevenueGrowth } from '../pages/revenue_reports/financialReport/RevenueGrowth'
import { FeedbackAndRatingReportIndex } from '../pages/revenue_reports/feedbackAndRatingReports/feedbackAndRatingReportIndex'
import { AverageRating } from '../pages/revenue_reports/feedbackAndRatingReports/AverageRating'
import { ReviewsAndComments } from '../pages/revenue_reports/feedbackAndRatingReports/ReviewsAndComments'
import Version from '../pages/settings/Version'

// import { Policy } from '@mui/icons-material';
// import useReduxStore from '../hooks/useReduxStore';

// Layouts
const CredentialLayout = lazy(() => import('../layout/credentials'))
const Layout = lazy(() => import('../layout'))

// Credentials
const Login = lazy(() => import('../pages/credentials/login'))
const ResetPassword = lazy(() => import('../pages/credentials/reset'))
const ForgotPassword = lazy(() => import('../pages/credentials/forgot'))

const Dashboard = lazy(() => import('../pages/dashboard'))

// Vendor management
const VendorManagement = lazy(() => import('../pages/vendor_management'))
const VendorDetails = lazy(() => import('../pages/vendor_management/details'))
const VendorLocation = lazy(() => import('../pages/vendor_management/loactions'))
const VendorCategory = lazy(() => import('../pages/vendor_management/Category'))
const VendorPlans = lazy(() => import('../pages/vendor_management/plans'))
const VendorPayments = lazy(() => import('../pages/vendor_management/payments'))
const VendorServices = lazy(() => import('../pages/vendor_management/services'))
const VendorTicket = lazy(() => import('../pages/vendor_management/ticket'))
const VendorBookings = lazy(() => import('../pages/vendor_management/bookings'))
const VendorTicketBookings = lazy(() => import('../pages/vendor_management/ticket-booking'))
const VendorTeamMembers = lazy(() => import('../pages/vendor_management/team-member'))
const VendorAssignPlan = lazy(() => import('../pages/vendor_management/assign-plan'))
const VendorOffers = lazy(() => import('../pages/vendor_management/offers'))
const UnlockHistory = lazy(() => import('../pages/vendor_management/unlock-history'))
const VendorBanner = lazy(() => import('../pages/vendor_management/banner'))

// Template Library
const TemplateLibrary = lazy(() => import('../pages/template_library'))
const CreateTemplate = lazy(() => import('../pages/template_library/create-template'))

const Chat = lazy(() => import('../pages/chat'))
// setup

const City = lazy(() => import('../pages/setup/city'))
const Country = lazy(() => import('../pages/setup/country'))
const State = lazy(() => import('../pages/setup/state'))
const BusinessCategories = lazy(() => import('../pages/setup/BusinessCategories'))
const SubBusinessCategory = lazy(() => import('../pages/setup/sub_bussness_category'))
const EventCategory = lazy(() => import('../pages/setup/event_category'))
const BannerImage = lazy(() => import('../pages/setup/BannerImage'))
const CartManagement = lazy(() => import('../pages/setup/cart-management'))

// roles permission
const Roles = lazy(() => import('../pages/roles'))
const RoleAndPermissions = lazy(() => import('../pages/roles/RoleAndPermissions'))
const TeamMember = lazy(() => import('../pages/roles/team_member'))
const RoleDetails = lazy(() => import('../pages/roles/team_member/Details'))
const AssignLocation = lazy(() => import('../pages/roles/assign-location'))
const AssignedLocation = lazy(() => import('../pages/roles/team_member/AssignedLocation'))

const ReviewManagement = lazy(() => import('../pages/review_management'))
const PlanManagement = lazy(() => import('../pages/plans_management'))
const PaymentManagement = lazy(() => import('../pages/payment_management'))
const Notifications = lazy(() => import('../pages/notifications'))

const RevenueReports = lazy(() => import('../pages/revenue_reports'))

const TicketEasyDetails = lazy(() => import('../pages/ticket_easy/index'))
const TicketEasy = lazy(() => import('../pages/ticket_easy/TicketEasy'))
const ClientTicketEasy = lazy(() => import('../pages/ticket_easy/ClientTicketEasy'))
const TicketDetails = lazy(() => import('../pages/ticket_easy/TicketDetails'))

//setting
const Setting = lazy(() => import('../pages/settings'))
const Policies = lazy(() => import('../pages/settings/Policies'))
const ChangePassword = lazy(() => import('../pages/settings/ChangePassword'))
const NotificationSettings = lazy(() => import('../pages/settings/NotificationSettings'))
const Queries = lazy(() => import('../pages/settings/Queries'))

const Profile = lazy(() => import('../pages/profile/index'))
const Profiledetails = lazy(() => import('../pages/profile/ProfileDetails'))

const CouponsAndOffers = lazy(() => import('../pages/coupons_&_Offers/index'))

const AllRoutes = () => {
    const { selector: user } = useReduxStore('auth')
    return (
        <>
            <Toaster position="top-right" reverseOrder={false} />
            <Routes>
                {!user?.token ? (
                    <Route path="/" element={<CredentialLayout />}>
                        <Route path="/" element={<Navigate replace to={'/login'} />} />
                        {/* Credentials */}
                        <Route path="login" element={<Login />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                        <Route path="reset-password/user/:id" element={<ResetPassword />} />
                        <Route path="reset-password/vendor/:id" element={<ResetPassword />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                    </Route>
                ) : (
                    <Route path="/" element={<Layout />}>
                        <Route path="/" element={<Navigate replace to={'/dashboard'} />} />
                        {/* Dashboard */}
                        <Route path="dashboard" element={<Dashboard />} />
                        {/* vendor management */}
                        <Route path="vendor-management" element={<VendorManagement />} />
                        <Route path="vendor-management/:id/plan/assign-plans" element={<VendorAssignPlan />} />
                        <Route path="vendor-management/:id" element={<VendorDetails />}>
                            <Route path="/vendor-management/:id" element={<Navigate replace to={'team-member'} />} />
                            <Route path="team-member" element={<VendorTeamMembers />} />
                            <Route path="location" element={<VendorLocation />} />
                            <Route path="category" element={<VendorCategory />} />
                            <Route path="plan" element={<VendorPlans />} />
                            <Route path="payment" element={<VendorPayments />} />
                            <Route path="services" element={<VendorServices />} />
                            <Route path="ticket" element={<VendorTicket />} />
                            <Route path="booking" element={<VendorBookings />} />
                            <Route path="offers" element={<VendorOffers />} />
                            <Route path="unlock-history" element={<UnlockHistory />} />
                            <Route path="banner" element={<VendorBanner />} />

                            <Route path="ticket-booking" element={<VendorTicketBookings />} />
                        </Route>
                        {/* Create Template */}
                        <Route path="template-library" element={<TemplateLibrary />} />
                        <Route path="template-library/create-template" element={<CreateTemplate />} />
                        <Route path="template-library/update-template/:id" element={<CreateTemplate />} />

                        <Route path="chat" element={<Chat />} />

                        {/* setup */}
                        <Route path="setup" element={<Navigate replace to={'/setup/services-categories-management'} />} />
                        <Route path="setup/services-categories-management" element={<BusinessCategories />} />
                        <Route path="setup/state" element={<State />} />
                        <Route path="setup/country" element={<Country />} />
                        <Route path="setup/city" element={<City />} />
                        <Route path="setup/sub-business-category" element={<SubBusinessCategory />} />
                        <Route path="setup/event-category" element={<EventCategory />} />
                        <Route path="setup/banner-image" element={<BannerImage />} />
                        <Route path="setup/cart-management" element={<CartManagement />} />

                        {/* roles & permission */}
                        <Route path="roles" element={<Navigate replace to={'/roles/team-member'} />} />
                        <Route path="roles/team-member" element={<TeamMember />} />
                        <Route path="roles/team-member/:id" element={<RoleDetails />}>
                            <Route path="/roles/team-member/:id" element={<Navigate replace to={'location'} />} />
                            <Route path="location" element={<AssignedLocation />} />
                        </Route>
                        <Route path="roles/permission" element={<Roles />} />
                        <Route path="roles/permission/:id" element={<RoleAndPermissions />} />

                        <Route path="roles/permission/assignlocation" element={<AssignLocation />} />
                        <Route path="roles/permission/addrole" element={<AssignLocation />} />
                        <Route path="roles/team-member/:id/assignlocation/" element={<AssignLocation />} />
                        <Route path="roles/team-member/:name/:id" element={<RoleDetails />} />
                        <Route path="roles/permission" element={<Roles />} />
                        <Route path="roles/permission/assignlocation" element={<AssignLocation />} />
                        <Route path="roles/permission/addrole" element={<AssignLocation />} />
                        <Route path="roles/team-member/:name/:id/assignlocation/" element={<AssignLocation />} />

                        <Route path="review-management" element={<ReviewManagement />} />
                        <Route path="plan-management" element={<PlanManagement />} />
                        <Route path="payment-management" element={<PaymentManagement />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="ticket-easy" element={<TicketEasyDetails />}>
                            <Route index element={<TicketEasy />} />
                            <Route path="client/ticket" element={<ClientTicketEasy />} />
                        </Route>
                        <Route path="ticket-easy/:id" element={<TicketDetails />} />
                        <Route path="ticket-easy/client/ticket/:id" element={<TicketDetails />} />

                        <Route path="coupons-&-offers" element={<CouponsAndOffers />} />

                        {/* <Route path="revenue-reports" element={<RevenueReports />} >
                            <Route path="/revenue-reports" element={<Navigate replace to={'booking-reports'} />} />
                            <Route path="booking-reports" element={<RevenueReports />} />
                            <Route path="due-payment" element={<DuePayments />} />
                        </Route> */}

                        <Route path="revenue-reports" element={<RevenueReports />}>
                            <Route index element={<Navigate replace to="user-report" />} />
                            <Route path="user-report" element={<UserReportIndex />}>
                                <Route index element={<Navigate replace to="Total_Registered_Users" />} />
                                <Route path="Total_Registered_Users" element={<TotalRegisteredUsers />} />
                                <Route path="Active_Inactive_Users" element={<ActiveInactiveUsers />} />
                                <Route path="User_Growth_Trends" element={<GrowthTrendsUsers />} />
                                <Route path="User_Demographics" element={<DemographicsUsers />} />
                                <Route path="Top_Engaged_Users" element={<TopEngagedUsers />} />
                            </Route>
                            <Route path="service-report" element={<ServiceReportIndex />}>
                                <Route index element={<Navigate replace to="Total_Requests_Per_Service" />} />
                                <Route path="Total_Requests_Per_Service" element={<TotalRequestsPerService />} />
                                <Route path="Average_Resolution_Time" element={<AverageResolutionTime />} />
                            </Route>
                            <Route path="financial-report" element={<FinancialReportIndex />}>
                                <Route index element={<Navigate replace to="BOOKING" />} />
                                <Route path="BOOKING" element={<Booking />} />
                                <Route path="PAYMENTRECEIVED" element={<PaymentReceived />} />
                                <Route path="REFUND" element={<Refund />} />
                                <Route path="COMMISSION" element={<Commission />} />
                                <Route path="REVENUEBREAKDOWN" element={<RevenueBreakdown />} />
                                <Route path="REVENUEGROWTH" element={<RevenueGrowth />} />
                                <Route path="RELEASEPAYMENT" element={<ReleasePayment />} />
                            </Route>
                            <Route path="feedbackAndRatingReports" element={<FeedbackAndRatingReportIndex />}>
                                <Route index element={<Navigate replace to="REVIEWANDCOMMENTS" />} />
                                <Route path="REVIEWANDCOMMENTS" element={<ReviewsAndComments />} />
                                <Route path="AVERAGERATING" element={<AverageRating />} />
                            </Route>
                        </Route>

                        {/*Settings */}
                        <Route path="settings" element={<Navigate replace to={'/settings/dashboard'} />} />
                        <Route path="settings/dashboard" element={<Setting />} />
                        <Route path="settings/policy" element={<Policies />} />
                        <Route path="settings/change-password" element={<ChangePassword />} />
                        <Route path="settings/notification" element={<NotificationSettings />} />
                        <Route path="settings/queries" element={<Queries />} />
                        <Route path="settings/version" element={<Version />} />

                        {/*Profile */}
                        <Route path="/profile" element={<Profile />}></Route>
                        <Route path="/profile/detail" element={<Profiledetails />}></Route>
                    </Route>
                )}
                <Route path="*" element={<Page404 />} />
            </Routes>
        </>
    )
}

export default AllRoutes
